import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Icon, Label, Message, Segment } from "semantic-ui-react";
import styles from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/legal/";

const PropertyReviewLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0]);

  const renderAccordionTips = () => {
    return (
        <>
        <Grid stackable doubling columns="equal" padded='vertically'>
          <Grid.Column stretched>
            <Segment raised className={styles.highlightsItemWhiteBG} >  
              <div style={{width: '100%', height: '100%', display: "inline-block"}}>
                <p className={styles.learnMoreAccordionText} > <br/>
                    It is important to find titles and deeds of all property and be sure they are stored in an accessible 
                    location. AgeReady provides a document storage and retrieval feature which can allow you and the older a
                    dult to keep these files online and easily accessible. 
                    <br/><br/>
                    There are attorneys who specialize in real estate and can be valuable in this process. It is important 
                    to know that a lot of this is state-specific. Each state has records of all real property and vehicles 
                    that need to be registered.
                </p><br/>
              </div>
            </Segment>  
          </Grid.Column>
        </Grid>
        </>
    );
  };


  const accordions = [
    { key: 'tips',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Tips for Property Review </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionTips()}/>)
      }
    },
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}propertyreview_main.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(PropertyReviewLearnMore);
